// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dB9E","content":"styles_content__3Q1nK","tableWrap":"styles_tableWrap__-mLRo"};